import { apiCall } from './generated/gqlClient';

const getAllPublicProductsApiRequest = async providerId => {
  const query = `
    query getPublicVideos($providerId: Int) {
      getPublicVideos(providerId: $providerId) {
        id
        name
        description
        price
        target
        imageUrl
        fileType
        category {
          id
          name
        }
        provider {
          id
          name
          type
        }
        files {
          id
          productId
          sectionId
          title
          description
          name
          type
        }
      }
    }
  `;
  return apiCall({ query, variables: { providerId: +providerId } });
};

export { getAllPublicProductsApiRequest };
